import React, { useEffect } from 'react'
import posthog from 'posthog-js'

interface PostHogProviderProps {
  children: React.ReactNode
}

export const PostHogProvider: React.FC<PostHogProviderProps> = ({
  children,
}) => {
  useEffect(() => {
    // PostHog configuration - hardcoded for production deployment
    const POSTHOG_KEY = 'phc_kxqzvShsQrVxJGtvJhYimrZJlg5ItfGioqzHPItyxNI'
    const POSTHOG_HOST = 'https://us.i.posthog.com'

    // Only initialize PostHog in production or when explicitly enabled
    const shouldInitialize =
      process.env.REACT_APP_ENV === 'production' ||
      process.env.REACT_APP_POSTHOG_ENABLED === 'true'

    if (shouldInitialize) {
      posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: 'identified_only',
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: true,
      })
    }
  }, [])

  return <>{children}</>
}
